/* custom-cart.js */
(function () {
  // --- simple logger ---
  var LOG = function(){ try{ console.log.apply(console, arguments); }catch(_){ } };

  // --- tiny waiter ---
  function waitFor(cond, { tries = 200, interval = 50 } = {}) {
    return new Promise(function (res, rej) {
      (function tick(left) {
        if (cond()) return res(true);
        if (left <= 0) return rej(new Error('waitFor timeout'));
        setTimeout(function(){ tick(left - 1); }, interval);
      })(tries);
    });
  }

  LOG('✅ custom-cart.js loaded');

  // Wait for jQuery + theme.cart
  waitFor(function () { return !!(window.jQuery && window.jQuery.fn); })
    .then(function () { LOG('[cart] jQuery ready:', jQuery.fn.jquery); })
    .then(function () { return waitFor(function(){ return window.theme && theme.cart; }); })
    .then(function () { LOG('[cart] theme.cart ready'); })
    .then(bootstrap)
    .catch(function (e) { console.error('[cart] bootstrap failed:', e); });

  function bootstrap() {
    var $ = window.jQuery;

    // 1) Ensure we don't stack handlers during theme editor reloads
    $('body').off('updateCart._cartCustom');

    // 2) Primary listener — theme triggers updateCart on BODY
    $('body').on('updateCart._cartCustom', function (ev, data) {
      LOG('[cart] updateCart received', data);

      if (!theme || !theme.cart || typeof theme.cart.getCart !== 'function') {
        console.warn('[cart] theme.cart.getCart missing; skip');
        return;
      }

      theme.cart.getCart().then(function (cart) {
        LOG('[cart] getCart resolved');

        // ---- YOUR BEHAVIOR ----
        var hasCustomCollection = $('.ctm_coll').length > 0;

        if (hasCustomCollection) {
          var nextBtn = $('.tab .active.tablinks').next('button').get(0);
          if (nextBtn) { LOG('[cart] clicking next tab'); nextBtn.click(); }

          var closeBtn = $('.screen-layer--is-active .js-screen-close').get(0);
          if (closeBtn) { LOG('[cart] closing screen layer'); closeBtn.click(); }
        } else {
          if (this && this.status && this.status.isDrawer && this.drawer && typeof this.drawer.open === 'function') {
            LOG('[cart] opening drawer');
            this.drawer.open();
          } else {
            LOG('[cart] drawer not opened (status/drawer missing or isDrawer=false)');
          }
        }
        // -----------------------
      }.bind(this)).catch(function (err) {
        console.error('[cart] getCart failed', err);
      });
    });

    // 3) Bridge native CustomEvent → jQuery(body) if your add-to-cart fires one
    if (!window.__addedAjaxProductBridgeInstalled) {
      document.addEventListener('added:ajaxProduct', function (ev) {
        LOG('[cart] bridge: added:ajaxProduct → updateCart', ev && ev.detail);
        $('body').trigger('updateCart', (ev && ev.detail) || {});
      });
      window.__addedAjaxProductBridgeInstalled = true;
      LOG('[cart] bridge installed for added:ajaxProduct');
    }

    // 4) Fallback: detect Shopify cart AJAX and emit updateCart ourselves
    //    (covers themes/apps that don’t re-emit the event)
    $(document).off('ajaxSuccess._cartCustom').on('ajaxSuccess._cartCustom', function (_e, xhr, settings) {
      try {
        if (!settings || !settings.url) return;
        var url = settings.url;
        if (url.indexOf('/cart/add') > -1 || url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1) {
          LOG('[cart] ajaxSuccess on', url, '→ trigger updateCart');
          $('body').trigger('updateCart', { from: 'ajaxSuccess' });
        }
      } catch (err) { /* noop */ }
    });

    // 5) Manual tester for the console
    window.__testUpdateCart = function (payload) {
      LOG('[cart] __testUpdateCart firing', payload);
      $('body').trigger('updateCart', payload || { from: 'console' });
    };

    LOG('[cart] custom-cart bootstrap complete (listening on BODY)');
  }
})();

